import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(6),
  },
  titleContainer: {
    background: theme.palette.grey[100],
    width: "100%",
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    color: theme.palette.text.primary,
  },
}));
